import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      // EmailJS configuration
      const serviceId = 'service_wxi4cli';
      const templateId = 'template_294qdph';
      const publicKey = 'rIJfV8Pv8hoA51554';
      
      // Prepare template parameters
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject || 'New Contact Form Submission',
        message: formData.message,
        to_email: 'sachin@graphicawork.online',
        // Additional parameters that might be needed
        name: formData.name,
        email: formData.email
      };
      
      console.log('Sending email with params:', templateParams);
      console.log('Service ID:', serviceId);
      console.log('Template ID:', templateId);
      console.log('Public Key:', publicKey);
      
      // Send email using EmailJS
      const result = await emailjs.send(serviceId, templateId, templateParams, publicKey);
      console.log('Email sent successfully:', result);
      
      // Success
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      
      // Reset status after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
      
    } catch (error) {
      console.error('Email sending failed:', error);
      setIsSubmitting(false);
      setSubmitStatus('error');
      
      // Reset error status after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  return (
    <main className="contact-page">
      <div className="contact-hero">
        <h1>Get In Touch</h1>
        <p>Ready to start your next project? Let's create something amazing together.</p>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <h2>Let's Connect</h2>
          <p>I'm always excited to hear about new projects and opportunities. 
            Whether you have a specific design need or just want to chat about possibilities, I'd love to hear from you.</p>
          
          <div className="contact-methods">
            <div className="contact-method">
              <div className="contact-icon">@</div>
              <div>
                <h3>Email</h3>
                <p>sachin@graphicawork.online</p>
              </div>
            </div>
            
            <div className="contact-method">
              <div className="contact-icon">ph</div>
              <div>
                <h3>Phone</h3>
                <p>+917426882205</p>
              </div>
            </div>
            
            <div className="contact-method">
              <div className="contact-icon">loc</div>
              <div>
                <h3>Location</h3>
                <p>Toronto, Ontario, Canada</p>
              </div>
            </div>
          </div>

          <div className="social-links">
            <h3>Follow My Work</h3>
            <div className="social-icons">
              <a
                className="social-link"
                href="https://www.instagram.com/wgraphica/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </div>
          </div>
        </div>

        <div className="contact-form-container">
          <h2>Send a Message</h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="What's this about?"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                placeholder="Tell me about your project..."
              ></textarea>
            </div>

            <button 
              type="submit" 
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>

            {submitStatus === 'success' && (
              <div className="success-message">
                Thank you! Your message has been sent successfully. I'll get back to you soon.
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="error-message">
                Sorry, there was an error sending your message. Please try again or contact me directly at sachin@graphicawork.online
              </div>
            )}
          </form>
        </div>
      </div>
    </main>
  );
}

export default Contact;
